import { render, staticRenderFns } from "./StokListesiDetay.vue?vue&type=template&id=ac7986fc"
import script from "./StokListesiDetay.vue?vue&type=script&lang=js"
export * from "./StokListesiDetay.vue?vue&type=script&lang=js"
import style0 from "./StokListesiDetay.vue?vue&type=style&index=0&id=ac7986fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports